import { SimpleError } from '@common/errors';
import { addPropertyField, ObjectData } from '../classes/ObjectData.js';
import { PatchMap } from '../classes/Patchable.js';
import { NullableDecoder } from './NullableDecoder.js';
import { PatchOrPutDecoder } from './PatchOrPutDecoder.js';
export class MapDecoder {
    keyDecoder;
    valueDecoder;
    constructor(keyDecoder, valueDecoder) {
        this.keyDecoder = keyDecoder;
        this.valueDecoder = valueDecoder;
    }
    patchType() {
        const elementDecoder = this.valueDecoder;
        if (elementDecoder.patchType) {
            const patchDecoder = elementDecoder.patchType();
            return new PatchMapDecoder(this.keyDecoder, new NullableDecoder(new PatchOrPutDecoder(this.valueDecoder, patchDecoder)));
        }
        return new PatchMapDecoder(this.keyDecoder, new NullableDecoder(this.valueDecoder));
    }
    patchDefaultValue() {
        return new PatchMap();
    }
    isPatchDefaultValue(value) {
        // Note: we cannot optimize here without instanceof - because setting it to a map is not the same as setting
        // typeof is too slow, so we optimize it here
        return typeof value === 'object' && value !== null && value._isPatchMap && value.size === 0;
    }
    decodeField(value, context, currentField) {
        if (typeof value === 'object' && value !== null) {
            const map = new Map();
            for (const key in value) {
                const field = addPropertyField(currentField, key);
                map.set(this.keyDecoder.decodeField ? this.keyDecoder.decodeField(key, context, field) : new ObjectData(key, context, field).decode(this.keyDecoder), this.valueDecoder.decodeField ? this.valueDecoder.decodeField(value[key], context, field) : new ObjectData(value[key], context, field).decode(this.valueDecoder));
            }
            return map;
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: `Expected an object at ${currentField}`,
            field: currentField,
        });
    }
    decode(data) {
        return this.decodeField(data.value, data.context, data.currentField);
    }
    isDefaultValue(value) {
        // typeof is too slow, so we optimize it here
        return /* value instanceof Map && */ typeof value === 'object' && value.size !== undefined && value.size === 0;
    }
    getDefaultValue() {
        return new Map();
    }
}
export class PatchMapDecoder {
    keyDecoder;
    valueDecoder;
    constructor(keyDecoder, valueDecoder) {
        this.keyDecoder = keyDecoder;
        this.valueDecoder = valueDecoder;
    }
    decode(container) {
        const data = container.field('changes');
        if (typeof data.value === 'object' && data.value !== null) {
            const map = new PatchMap();
            for (const key in data.value) {
                const keyDecoded = data.clone({
                    data: key,
                    context: data.context,
                    field: data.addToCurrentField(key),
                }).decode(this.keyDecoder);
                const valueDecoded = data.field(key).decode(this.valueDecoder);
                map.set(keyDecoded, valueDecoded);
            }
            return map;
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: `Expected an object at ${data.currentField}`,
            field: data.currentField,
        });
    }
    isDefaultValue(value) {
        return value instanceof PatchMap && value.size === 0;
    }
    getDefaultValue() {
        return new PatchMap();
    }
}
//# sourceMappingURL=MapDecoder.js.map